import React from 'react';

import { AdditionalInfo } from '../../api/api';
import { GeneralError } from '../commons/components/general-error';
import { FullscreenMode } from '../fullscreen-internals/fullscreen-mode';
import { useAdditionalInfoMutation } from './additional-info-mutation';
import { CustomerNumberModal } from './customer-number-extension';

interface CustomerNumberProviderChildProps {
  onOpen: () => void;
}

interface CustomerNumberProviderProps {
  children: (props: CustomerNumberProviderChildProps) => React.ReactNode;
  onSuccess?: () => void;
}

export const CustomerNumberProvider: React.FC<CustomerNumberProviderProps> = ({
  children,
  onSuccess,
}) => {
  /**
   * For customer number we need to wait until it is set on backend, so we show
   * a loader and in general make this call non-optimistic for simplicity.
   */
  const mutation = useAdditionalInfoMutation({ mutationKey: ['customer-number'] });
  const [modalOpen, setModalOpen] = React.useState<boolean>(false);

  function renderModal() {
    if (!modalOpen) {
      return null;
    }

    const onSubmit = (values: AdditionalInfo) => {
      mutation.mutate(values, { onSuccess });
      setModalOpen(false);
    };

    return (
      <FullscreenMode>
        <CustomerNumberModal onSubmit={onSubmit} onClose={() => setModalOpen(false)} />
      </FullscreenMode>
    );
  }

  const childProps = {
    onOpen: () => setModalOpen(true),
  };

  return (
    <>
      {children(childProps)}
      {renderModal()}
      <GeneralError error={mutation.error} onClose={mutation.reset} />
    </>
  );
};
